import { TextField } from '@mui/material'
import React from 'react'
import { empresas } from 'service/api'
import { useStore } from 'store'
import Menu from '../MenuV2'
import { SelectProps } from './types'

export const SelectEmpresa: React.FC<SelectProps> = ({
    size = 'small',
    variant = 'filled',
    width = 260,
    children,
    helperText,
    disabled,
    hideWhenSingle = false,
}) => {
    const companyId = useStore(state => state.companyId)
    const { data = [], isFetched } = empresas.useFetch()

    const handleClick = (id: number) => {
        return () => {
            const empresa = data?.find(({ id: _id }) => _id === id)!
            useStore.setState({ company: empresa, companyId: id })
        }
    }

    if (hideWhenSingle && data.length <= 1 && isFetched) {
        return null
    }

    return (
        <TextField
            label="Empresa"
            fullWidth
            variant={variant}
            select
            size={size}
            sx={{ width }}
            defaultValue={companyId}
            helperText={helperText}
            SelectProps={{
                value: companyId,
                MenuProps: {
                    PaperProps: {
                        sx: {
                            maxHeight: '50vh',
                            maxWidth: width,
                        },
                    },
                },
            }}
            onKeyDownCapture={e => e.stopPropagation()}
            disabled={disabled}
        >
            {children}
            {data?.map(({ id, nomeFantasia }, index) => (
                <Menu.Item
                    className="block truncate"
                    onClick={handleClick(id)}
                    key={index}
                    value={id}
                    title={nomeFantasia}
                >
                    {nomeFantasia}
                </Menu.Item>
            ))}
        </TextField>
    )
}
